<!--
 * @Author: your name
 * @Date: 2022-05-30 13
-->
<template>
  <div class="dynamic-row">
    <div class="bast-dynamic-detail">
      <div class="bast-dynamic-detail-boxss">
        <div v-for="(item,idx) in dynamicList" :key="idx"
          class="bast-dynamic-detail-item"
          @click="topath(item)"
        >
          <div class="item-box">
            <div class="left animate__animated animate__fadeInLeft animate__slow">
              <img :src="item.preview" alt="" class="bast-dynamic-detail-img">
            </div>
            <div class="right animate__animated animate__fadeInRight animate__slow">
              <p class="text-1">{{item.title}}</p>
              <div class="bast-dynamic-detail-times">
                <img src="@/assets/time-icon.png" alt="" class="bast-dynamic-detail-icon">
                <p class="text-2"> {{item.create_time}} </p>
              </div>
              <p class="text-3">{{item.description}}</p>
              <div class="details-btn">了解详情</div>
            </div>
          </div>
        </div>
      </div>
      <!-- 查看更多 -->
        <examine-more v-if="moreShow" @examine="examine" :moreLoading='moreLoading'></examine-more>
    </div>
  </div>
</template>
<script>
import { newsListApi } from "../../../../request/api"
import examineMore from '@/components/examineMore'
import SecondTitle from '@/components/SecondTitle'
export default {
  components:{
    SecondTitle,
    examineMore
  },
  data(){
    return{
      moreLoading:false,
      moreShow:true,
      page:1,
      page_size:10,
      activeName: "trends",
      dynamicList:[
        {
          id:'1',
          name:'500R经典版，29999元诚意驾临！',
          img:require('@/assets/img/news/news-icon.jpg'),
          time:'2022-2-25',
        },
        {
          id:'2',
          name:'500R经典版，29999元诚意驾临！',
          img:require('@/assets/img/news/news-icon2.png'),
          time:'2022-2-25',
        },
        {
          id:'3',
          name:'500R经典版，29999元诚意驾临！',
          img:require('@/assets/img/news/news-icon3.png'),
          time:'2022-2-25',
        },
        {
          id:'4',
          name:'500R经典版，29999元诚意驾临！',
          img:require('@/assets/img/news/news-icon.jpg'),
          time:'2022-2-25',
        },
        {
          id:'5',
          name:'500R经典版，29999元诚意驾临！',
          img:require('@/assets/img/news/news-icon2.png'),
          time:'2022-2-25',
        },
        {
          id:'6',
          name:'500R经典版，29999元诚意驾临！',
          img:require('@/assets/img/news/news-icon3.png'),
          time:'2022-2-25',
        },
        {
          id:'7',
          name:'500R经典版，29999元诚意驾临！',
          img:require('@/assets/img/news/news-icon.jpg'),
          time:'2022-2-25',
        },
        {
          id:'8',
          name:'500R经典版，29999元诚意驾临！',
          img:require('@/assets/img/news/news-icon2.png'),
          time:'2022-2-25',
        },
        {
          id:'9',
          name:'500R经典版，29999元诚意驾临！',
          img:require('@/assets/img/news/news-icon3.png'),
          time:'2022-2-25',
        },
      ],
      baseTabs:{
        list:[
        { 
          label: "无极动态", 
          name: "trends", 
          englithTitle: "oge Events", 
          englithA:"V", 
          changname:"无极动态", 
          addone:"新闻潮汛", 
          addtow:"无极动态"
        },
        { 
          label: "最新活动", 
          name: "activity", 
          englithTitle: "oge Events", 
          englithA:"V", 
          changname:"最新活动", 
          addone:"新闻潮汛", 
          addtow:"最新活动"
        },
        { 
          label: "媒体测评", 
          name: "appraisal", 
          englithTitle: "oge Events", 
          englithA:"V", 
          changname:"媒体测评", 
          addone:"新闻潮汛", 
          addtow:"媒体测评"
        },
      ]
      }
    }
  },
  created(){
    this.newsListApi()
  },
  methods:{
    examine(){
      this.page++
      this.newsListApi()
      this.moreLoading = true
    },
    // 文章数据
    newsListApi(){
      const params = {
        m:'Mobile',
        c:'Article',
        a:'get_all_news_list',
        type:'6',
        lang:'1',
        page:this.page,
        page_size:this.page_size
      }
      newsListApi(params).then(({data})=>{
        this.moreLoading = false
        if (this.page == 1) {
          this.dynamicList = data.datas.info
          if (this.page*this.page_size > data.datas.count) {
              this.moreShow = false
          }
        }else{
          data.datas.info.forEach((item,idx) => {
            if (this.page*this.page_size <= data.datas.count) {
              this.dynamicList.push(item)
            }
            if (this.page*this.page_size > data.datas.count) {
              this.dynamicList.push(item)
              this.moreShow = false
            }
          });
        }
        
      })
    },
    // 跳转详情
    topath(item){
      this.$router.push('/news-tidal-details?id=' + item.articel_id)
      localStorage.setItem("content",item.content)
    }
  },
}
</script>
<style lang="scss">
@import "./appraisal.scss";
</style>


// WEBPACK FOOTER //
// src/views/news-tidal/appraisal/appraisal.vue